module.exports = "\r\n<div>\r\n  <app-placement-reservation-list></app-placement-reservation-list>\r\n</div>\r\n"